import React from "react";
import Layout from "./../components/layout/Layout";
import Article from "../components/layout/Article";
import SEO from "../components/SEO";
import BlogPostCard from "../components/BlogPostCard";
import { graphql } from "gatsby";

const CategoryPostsPage = ({ pageContext: { title }, data }) => {
  // console.table(data.allMdx.edges.map(({ node }) => node.frontmatter));
  const { edges } = data.allMdx;

  return (
    <Layout sidebar={{ recentPosts: true, search: true }}>
      <SEO title={title} />
      <Article title={title}>
        <ul style={{ margin: 0 }} className="divide-y">
          {(edges || []).map(({ node }) => {
            const {
              id,
              excerpt,
              frontmatter: {
                title,
                category,
                date,
                featured_image: { thumbnail },
              },
              fields: { slug },
            } = node;

            return (
              <BlogPostCard
                key={id}
                title={title}
                thumbnail={thumbnail}
                slug={slug}
                excerpt={excerpt}
                date={date}
                category={category}
              />
            );
          })}
        </ul>
      </Article>
    </Layout>
  );
};

export const categoryPostsPageQuery = graphql`
  query($category: String) {
    allMdx(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { category: { in: [$category] } } }
    ) {
      totalCount
      edges {
        node {
          id
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMM DD, YYYY")
            title
            category
            featured_image {
              thumbnail: img {
                childImageSharp {
                  fluid(maxWidth: 650, quality: 90) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default CategoryPostsPage;
